import type { MyInfoApiResponse } from '../../features/me/me.models';

/**
 * /api/v0/me Mockデータ
 *
 * mockモードのログインユーザー情報。
 * tenantAdmin ロールで全グループに writable アクセスを持つテナントに所属。
 */
export const MOCK_MY_INFO: MyInfoApiResponse = {
  publicId: 'user-mock-001',
  email: 'mock-user@example.com',
  name: 'テストユーザー',
  tenants: [
    {
      publicId: 'tenant-mock-001',
      name: 'GX',
      role: 'tenantAdmin',
      userType: 'Customer',
      permissions: [
        {
          groupId: '*',
          access: 'writable',
        },
      ],
      // テナント全体スコープのため祖先グループの補完は不要
      ancestorGroups: [],
    },
    {
      publicId: 'tenant-mock-002',
      name: 'GX事務局',
      role: 'tenantAdmin',
      userType: 'Customer',
      permissions: [
        {
          groupId: '*',
          access: 'writable',
        },
      ],
      // テナント全体スコープのため祖先グループの補完は不要
      ancestorGroups: [],
    },
  ],
};
